module.exports = __webpack_public_path__ + "banquet/containers/MarketingPricingContainer/images/audience.9502b45a0da87e6ed3fd8530acdc093b.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/containers/MarketingPricingContainer/images/audience.svg
// module id = 1713
// module chunks = 1